module.exports = __webpack_public_path__ + "img/doKument_logo_1.d188ef13.png";